import styled, { css } from "styled-components";
import type { CollapseVariantsType } from "./Collapse";

// STYLES
const basket = css`
    header {
        display: flex;
        column-gap: var(--spacing-1);
        align-items: center;

        &:has(button) {
            cursor: pointer;
        }
    }

    button[aria-expanded="true"] {
        .dxp-icon,
        svg {
            transform: rotate(180deg);
        }
    }
`;

const disclaimer = css`
    position: relative;

    header {
        display: flex;
        column-gap: var(--spacing-1);
        align-items: center;

        &:has(button) {
            cursor: pointer;
        }
    }

    button[aria-expanded="true"] {
        .dxp-icon,
        svg {
            transform: rotate(180deg);
        }
    }

    &[aria-expanded="false"] {
        max-height: 50px;
        overflow: hidden;

        &::after {
            display: block;
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 20px;
            content: "";
            background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
        }
    }
`;

const defaultCollapse = ``;

// COMPONENTS
export const CollapseVariants = {
    default: defaultCollapse,
    basket,
    disclaimer,
};

const CollapseVariant = styled.div<{ variant: CollapseVariantsType }>`
    ${({ variant }) =>
        variant &&
        css`
            ${CollapseVariants[variant]};
        `};
`;

export default CollapseVariant;
